/**
 * Utilitaire pour générer les URLs d'images depuis le backend
 * Les images sont stockées dans backend/public/images/
 * et servies par Express sur le backend API
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1'
// Extraire l'URL de base du backend (sans /api/v1 ou /v1)
const BACKEND_BASE_URL = API_BASE_URL.replace(/\/api\/v1$/, '').replace(/\/v1$/, '')

/**
 * Transforme un chemin d'image relatif en URL complète vers le backend
 * @param imagePath - Chemin relatif (ex: /images/graffitis/thumbnails/image.JPG)
 * @returns URL complète vers le backend
 */
export function getImageUrl(imagePath: string | null | undefined): string | null {
  if (!imagePath) return null

  // Si c'est déjà une URL complète, la retourner telle quelle
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath
  }

  // Si le chemin commence par /images, le servir depuis le backend
  if (imagePath.startsWith('/images')) {
    return `${BACKEND_BASE_URL}${imagePath}`
  }

  // Sinon, retourner le chemin tel quel (pour compatibilité)
  return imagePath
}

/**
 * Récupère l'URL de la miniature d'une image
 */
export function getThumbnailUrl(image: {
  filePathThumbnail?: string | null
  filePathHd?: string | null
}): string | null {
  return getImageUrl(image.filePathThumbnail) || getImageUrl(image.filePathHd)
}

/**
 * Récupère l'URL HD d'une image
 */
export function getHdUrl(image: {
  filePathHd?: string | null
  filePathThumbnail?: string | null
}): string | null {
  return getImageUrl(image.filePathHd) || getImageUrl(image.filePathThumbnail)
}
